if (!customElements.get('product-stock-status')) {
  class ProductStockStatus extends HTMLElement {
    constructor() {
      super();

      this.messageEl = this.querySelector('[data-status-message]');
      this.detailEl = this.querySelector('[data-status-detail]');
      this.countdownEl = this.querySelector('[data-dispatch-countdown]');
      this.countdownRowEl = this.querySelector('[data-dispatch-countdown-row]');
      this.dispatchTextEl = this.querySelector('[data-dispatch-countdown-text]');
      this.variantData = this.getVariantData();
      this.cutoffHour = Number(this.dataset.cutoffHour || 15);
      this.cutoffTimeZone = this.dataset.cutoffTimeZone || 'Europe/Copenhagen';
      this.variantId = this.dataset.currentVariantId;

      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('.js-product');
      this.section?.addEventListener('on:variant:change', this.handleVariantChange);

      this.updateStatus(this.variantId);
      this.startCountdown();
    }

    disconnectedCallback() {
      this.section?.removeEventListener('on:variant:change', this.handleVariantChange);
      window.clearInterval(this.countdownTimer);
    }

    handleVariantChange(event) {
      this.updateStatus(event.detail.variant?.id);
    }

    getVariantData() {
      const dataEl = this.querySelector('script[type="application/json"]');

      if (!dataEl) return {};

      try {
        return JSON.parse(dataEl.textContent);
      } catch (error) {
        return {};
      }
    }

    updateStatus(variantId) {
      const variantStatus = this.variantData[variantId];
      const status = variantStatus?.status || 'sold_out';

      this.classList.remove(
        'product-stock-status--in_stock',
        'product-stock-status--backorder',
        'product-stock-status--sold_out'
      );
      this.classList.add(`product-stock-status--${status}`);

      if (status === 'in_stock') {
        this.messageEl.textContent = 'På lager';
        this.updateDispatchPromise();
        return;
      }

      this.countdownRowEl.hidden = true;

      if (status === 'backorder') {
        this.messageEl.textContent = 'Restordre';
        this.detailEl.textContent = variantStatus?.restockDate
          ? `Forventes på lager ${variantStatus.restockDate}`
          : 'Kan bestilles nu';
        return;
      }

      this.messageEl.textContent = 'Udsolgt';
      this.detailEl.textContent = 'Denne variant er ikke på lager lige nu';
    }

    startCountdown() {
      this.updateCountdown();
      this.countdownTimer = window.setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
      if (!this.countdownEl || this.countdownRowEl.hidden || this.countdownEl.hidden) return;

      const timeParts = this.getCurrentTimeParts();
      const nowTime = Date.UTC(
        timeParts.year,
        timeParts.month - 1,
        timeParts.day,
        timeParts.hour,
        timeParts.minute,
        timeParts.second
      );
      const cutoffTime = Date.UTC(
        timeParts.year,
        timeParts.month - 1,
        timeParts.day,
        this.cutoffHour,
        0,
        0
      );
      const difference = cutoffTime - nowTime;

      if (difference <= 0) {
        this.updateDispatchPromise();
        return;
      }

      const hours = Math.floor(difference / 3600000);
      const minutes = Math.floor((difference % 3600000) / 60000);
      const seconds = Math.floor((difference % 60000) / 1000);
      const pad = (value) => String(value).padStart(2, '0');

      this.countdownEl.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    }

    updateDispatchPromise() {
      const timeParts = this.getCurrentTimeParts();
      const isWeekend = timeParts.weekday === 6 || timeParts.weekday === 7;
      const isBeforeCutoff = timeParts.hour < this.cutoffHour;

      if (!isWeekend && isBeforeCutoff) {
        this.detailEl.textContent = 'Afsendes i dag';
        this.dispatchTextEl.textContent = 'Bestil inden kl. 15:00';
        this.countdownRowEl.hidden = false;
        this.countdownEl.hidden = false;
        this.updateCountdown();
        return;
      }

      this.countdownRowEl.hidden = false;
      this.countdownEl.hidden = true;

      if (!isWeekend && timeParts.weekday < 5) {
        this.detailEl.textContent = 'Afsendes i morgen';
        this.dispatchTextEl.textContent = 'Bestil i morgen inden kl. 15:00';
        return;
      }

      this.detailEl.textContent = 'Afsendes mandag';
      this.dispatchTextEl.textContent = 'Bestil mandag inden kl. 15:00';
    }

    getCurrentTimeParts() {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.cutoffTimeZone,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const weekdays = {
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
        Sun: 7
      };

      return formatter.formatToParts(new Date()).reduce((parts, part) => {
        if (part.type === 'weekday') {
          parts.weekday = weekdays[part.value];
        } else if (part.type !== 'literal') {
          parts[part.type] = Number(part.value);
        }

        return parts;
      }, {});
    }
  }

  customElements.define('product-stock-status', ProductStockStatus);
}
